import type {
  AccordionPageBlock,
  ContentSliderPageBlock,
  PageBlock,
  TabContainerPageBlock,
} from "@/types/page-block";

export function hasSysId(item: unknown): item is { sys: { id: string } } {
  return (
    item !== null &&
    typeof item === "object" &&
    "sys" in item &&
    item.sys !== null &&
    typeof item.sys === "object" &&
    "id" in item.sys &&
    typeof (item.sys as { id: unknown }).id === "string"
  );
}

export function* collectServerBlocks(
  blocks: PageBlock[]
): Generator<PageBlock> {
  for (const block of blocks) {
    yield block;
    if (block.__typename === "AccordionD2C") {
      for (const item of (block as AccordionPageBlock).items) {
        yield* collectServerBlocks(item.children);
      }
    } else if (block.__typename === "ContentSliderD2C") {
      yield* collectServerBlocks((block as ContentSliderPageBlock).slides);
    } else if (block.__typename === "TabContainerD2C") {
      for (const item of (block as TabContainerPageBlock).items) {
        yield* collectServerBlocks(item.children);
      }
    }
  }
}
